import { useAuthContext } from 'src/auth/hooks';

export function useUserType(userTypes) {
  const { user } = useAuthContext();
  if (!userTypes) return true;

  const userRoles = user?.role?.map((role) => role.name) || [];

  return userTypes.some((type) => userRoles.includes(type));
}
